import { featureService } from '@api/services/feature/feature.apiService';
import { FeatureFlags, FeatureTypes } from '@api/services/feature/feature.apiService.interfaces';
import { keyMap } from '@locales/lokalise/keyMap';
import { handleError } from '@utils/errors';
import { makeAutoObservable, runInAction } from 'mobx';
import type { MobxRootStore } from './mobx.store';

export class FeaturesStore {
  mobxStore: MobxRootStore;
  private _isFeaturesProcessing = false;
  private _isFeaturesLoaded = false;
  private _featureFlags: FeatureFlags = {
    TradingContests: false,
    SocialTrading: false,
    Bonuses: false,
    MAM: false,
    EducationalPortal: false,
    LoyaltyPrograms: false,
    CustomNotifications: false,
    EmailTemplates: false,
    CustomPushNotifications: false,
    PartnershipPortal: false,
  };

  constructor(mobxStore: MobxRootStore) {
    this.mobxStore = mobxStore;
    makeAutoObservable(this);
  }

  fetchFeatureFlags = async () => {
    this._isFeaturesProcessing = true;
    try {
      const { data: features } = await featureService.getAll();

      if (features) {
        runInAction(() => {
          this._featureFlags = features;
          this._isFeaturesProcessing = false;
          this._isFeaturesLoaded = true;
        });
      }
    } catch (error) {
      handleError(keyMap.sharedErrorsFailedToGetSettings, error);
      this._isFeaturesProcessing = false;
    }
  };

  isFeatureEnabled = (feature?: FeatureTypes): boolean => {
    if (!feature) {
      return true;
    }

    return this._featureFlags[feature];
  };

  get featureFlags() {
    return this._featureFlags;
  }

  get isFeaturesProcessing() {
    return this._isFeaturesProcessing;
  }

  get isFeaturesLoaded() {
    return this._isFeaturesLoaded;
  }
}
